import { VariantProps } from "class-variance-authority";
import { forwardRef, type ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { badgeVariants } from "./styles";

export interface BadgeProps extends ComponentProps<"span">, VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, ...props }, ref) => (
  <span ref={ref} data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
));
Badge.displayName = "Badge";
